import React, { Dispatch, SetStateAction } from 'react';

import { Tabs, Tab, Typography } from '@mui/material';

import { useTheme } from '@mui/material/styles';

const ResultTab = ({ color, colorzh, ...tabProps }: { color: string, colorzh: string }) => (
  <Tab
    {...tabProps}
    sx={{
      height: 32,
      minHeight: 32,
      '&.Mui-selected': {
        color: color
      }
    }}
    label={<Typography variant='body1'>{colorzh}</Typography>}
  />
)

const ResultTabs = (props: {
  value: number,
  setValue: Dispatch<SetStateAction<number>>,
  show?: boolean[],
}) => {

  const theme = useTheme();

  const indicatorColors = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
    theme.palette.error.main,
    theme.palette.secondary.light,
  ];
  const indicatorColorsZh = ['綠', '黃', '紅', 'PAY'];

  const { value, setValue, show } = props;

  const color = indicatorColors[value];
  const colorzh = indicatorColorsZh[value];

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  }

  return (
    <Tabs value={0} aria-label='basic tabs example'
      sx={(theme) => ({
        minHeight: 32,
        '& .MuiTabs-indicator': {
          backgroundColor: indicatorColors[value],   // indicator color
        },
      })}
    // onChange={handleChange}
    >
      {/*
        indicatorColors.map((color, index) => (
          show[index] && <ResultTab key={color} color={color} colorzh={indicatorColorsZh[index]} />
        ))
      */}
      <ResultTab key={color} color={color} colorzh={colorzh} />
    </Tabs>
  )
}

export default ResultTabs;